<template>
  <div>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-text-xs wf-tracking-wide wf-font-light wf-lowercase">on click</span>
      <div class="wf-flex wf-w-1/2">
        <select name="on_click" v-model="clickAction" class="wf-w-full">
          <option
            v-for="option in clickOptions"
            :value="option.value"
            :key="option.value"
            v-text="option.text"
          ></option>
        </select>
      </div>
    </li>
    <li v-if="clickAction == 'external_link' || clickAction == 'image'" class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-text-xs wf-tracking-wide wf-font-light wf-lowercase">target</span>
      <div class="wf-flex wf-w-1/2">
        <select class="wf-w-full" v-model="clickTarget">
          <option value="__blank">new window</option>
          <option value="__self">same window</option>
        </select>
      </div>
    </li>
  </div>
</template>

<script>
  import MenuContentProperty from '../contracts/MenuContentProperty'
  export default MenuContentProperty.extend({
    computed: {
      clickOptions() {
        return [
          {value: 'none', text: 'do nothing'},
          {value: 'image', text: 'open image'},
          {value: 'external_link', text: 'open external link'},
          {value: 'lightbox', text: 'open lightbox'},
        ]
      },
      clickAction: {
        get() {
          return this.elementContent['clickAction']
        },
        set(value) {
          this.addToObject(this.module, {clickAction: value}, 'content', null, {}, true, this.parentModule)
        }
      },
      clickTarget: {
        get() {
          return this.elementContent['clickTarget']
        },
        set(value) {
          this.addToObject(this.module, {clickTarget: value}, 'content', null, {}, true, this.parentModule)
        }
      },
    }
  })
</script>